import { render, staticRenderFns } from "./WidgetEditor.vue?vue&type=template&id=b4e51024&lang=pug"
import script from "./WidgetEditor.vue?vue&type=script&lang=js"
export * from "./WidgetEditor.vue?vue&type=script&lang=js"
import style0 from "./WidgetEditor.vue?vue&type=style&index=0&id=b4e51024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports